import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { assetCategoriesColumn } from '../../../datatablesource';
import { handleError } from '../../../utils/error';
import newRequest from '../../../utils/newRequest';
import Datatable from '../../datatable/Datatable';
import "./assetCategories.scss";
import { useTranslation } from 'react-i18next';

const AssetCategories = () => {
    const navigate = useNavigate();
  const { t, i18n } = useTranslation();
    const [assetCategoriesList, setAssetCategoriesList] = useState([]);
     const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        const getAssetMasterCapture = async () => {
            try {
                const response = await newRequest.get("/GetAllMAINSUBSeriesNo")
                console.log(response?.data);
                setAssetCategoriesList(response?.data);
                setIsLoading(false);
            }
            catch (error) {
                handleError(error)
 setIsLoading(false);
            }
        };
        getAssetMasterCapture();
    }, []);
    return (
      <>
        <div>
          <Datatable
            columnsName={assetCategoriesColumn(t)}
            data={assetCategoriesList}
            secondaryColor="secondary"
            title={t("ASSET CATEGORIES")}
            apiEndPoint="/PostMAINSUBSeriesNo"
            addNewNavigation="/admin/database-config/asset-categories/add-new-asset-category"
            deleteBtnEndPoint="/DeleteMAINSUBSeriesNoById"
            checkboxSelectionOption={false}
            loading={isLoading}
            uniqueId={"assetCategoriesId"}
          />
        </div>
      </>
    );
}

export default AssetCategories